export const wait = (msec: number) =>
  new Promise((resolve) => setTimeout(resolve, msec));
